import './LocationProfileForm.scss';

import React, { PureComponent } from 'react';
import { List, Map } from 'immutable';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Text from 'components/Text';

import cxHelpers from 'util/className';
import { toI18n } from 'util/i18n';

import CompanyProfileFormField from '../CompanyProfileFormField';
import LocationProfileRows from '../LocationProfileRows';

@cxHelpers('LocationProfileForm')
export default class LocationProfileForm extends PureComponent {
  static propTypes = {
    locationProfile: PropTypes.instanceOf(Map).isRequired,
    jobRequests: PropTypes.instanceOf(Map).isRequired,
    states: PropTypes.instanceOf(List).isRequired,
  };

  constructor(props) {
    super(props);

    this.states = props.states
      .toArray()
      .map(([label, value]) => ({ label, value }));
  }

  render() {
    const { locationProfile, jobRequests } = this.props;

    return (
      <div className={this.cx()}>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div className="box">
              <Box bradius b paxl>
                <p className={this.cxEl('form-header')}>
                  <Text i18n="hiring.company_profile.location_address" />
                </p>
                <CompanyProfileFormField
                  fieldName={`location_profiles.${locationProfile.get(
                    'id'
                  )}.address_1`}
                  placeholder={toI18n(
                    'hiring.company_profile.location_address_form.address_1'
                  )}
                  editing
                />
                <CompanyProfileFormField
                  fieldName={`location_profiles.${locationProfile.get(
                    'id'
                  )}.address_2`}
                  placeholder={toI18n(
                    'hiring.company_profile.location_address_form.address_2'
                  )}
                  editing
                />
                <CompanyProfileFormField
                  fieldName={`location_profiles.${locationProfile.get(
                    'id'
                  )}.city`}
                  placeholder={toI18n(
                    'hiring.company_profile.location_address_form.city'
                  )}
                  editing
                />
                <Box vcenter className={this.cxEl('half-width')}>
                  <CompanyProfileFormField
                    fieldName={`location_profiles.${locationProfile.get(
                      'id'
                    )}.state`}
                    inputType="select"
                    placeholder={toI18n(
                      'hiring.company_profile.location_address_form.state'
                    )}
                    options={this.states}
                    editing
                  />
                  <CompanyProfileFormField
                    fieldName={`location_profiles.${locationProfile.get(
                      'id'
                    )}.zip`}
                    placeholder={toI18n(
                      'hiring.company_profile.location_address_form.zip'
                    )}
                    editing
                  />
                </Box>
              </Box>
            </div>
          </div>

          <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
            <div className="box">
              <p className={this.cxEl('form-header')}>
                <Text i18n="hiring.company_profile.location_name" />
              </p>
              <CompanyProfileFormField
                fieldName={`location_profiles.${locationProfile.get(
                  'id'
                )}.title`}
                placeholder={toI18n(
                  'hiring.company_profile.location_address_form.title'
                )}
                editing
              />

              <hr />

              <LocationProfileRows
                locationProfile={locationProfile}
                jobRequests={jobRequests}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
